import StyledLink from '../StyledLink'
import { ENVIRONMENTS } from '../routes'
import type { Props } from '../types'

const LinkToEnvironments = ({
  children,
  isHyperlink
}: Props) => {
  const toUrl = `/${ENVIRONMENTS}`

  return (
    <StyledLink
      isHyperlink={isHyperlink}
      to={toUrl}
    >
      {children}
    </StyledLink>
  )
}

export default LinkToEnvironments
